import { Fragment, useEffect, useState } from "react";
import { FilterRight, ChevronDown } from "react-bootstrap-icons";
import "./style.css";

import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "Redux/Actions/CategoryActions";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { useLocation } from "react-router-dom";

import EachChooseList from "./EachChooseList";

const ChooseCtegory = ({ catBox }) => {
  const [titleSelectSub, setTitleSelectSub] = useState("");
  const dispatch = useDispatch();
  const data = useSelector((state) => state.category.categories);

  const { pathname } = useLocation();

  useEffect(() => {
    const [_, section, id] = pathname.split("/");
    if (section === "category") {
      const findID = data?.find((item) => item.id === parseInt(id));
      setTitleSelectSub(findID?.name);
    } else if (section === "sub_category") {
      findSubCatID(id);
    }
    // eslint-disable-next-line
  }, [pathname, data]);

  const findSubCatID = (id) => {
    for (let catItem of data) {
      const findID = catItem?.business_sub_category?.find(
        (item) => item.id === parseInt(id)
      );
      if (findID) {
        setTitleSelectSub(findID?.name);
        break;
      }
    }
  };

  useEffect(() => {
    dispatch(getCategories());
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div className="title-select-sub-category d-flex justify-content-start align-items-center border-0 bg-dap-success  py-2 px-3 mb-2">
        <FilterRight
          className="ms-3 ps-2 border-start"
          size={30}
          color="white"
        />
        <h6 className="mb-0 text-white font-site ">{titleSelectSub}</h6>
      </div>
      <div className="all-choose-category  ps-2  overflow-auto">
        {data.map((eachCategory) => {
          return (
            <Fragment key={eachCategory.id}>
              <Accordion allowZeroExpanded>
                <AccordionItem className="py-2 px-1  border mb-2">
                  <AccordionItemHeading>
                    <AccordionItemButton className=" d-flex align-items-center p-2">
                      <img
                        src={`https://images.daapapp.com/${eachCategory.selected_img}`}
                        alt=""
                        className="ms-1 img-choose-sub"
                      />
                      <p className="ms-auto bg-success-light p-0 m-0">
                        {eachCategory.name}
                      </p>
                      <ChevronDown size={23} className=" mx-2" />
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel className="bg-dap-menu ">
                    {eachCategory.business_sub_category.map((EachSub) => {
                      return (
                        <EachChooseList
                          catBox={catBox}
                          key={EachSub.id}
                          id={EachSub.id}
                          name={EachSub.name}
                          setTitleSelectSub={setTitleSelectSub}
                        />
                      );
                    })}
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            </Fragment>
          );
        })}
      </div>
    </Fragment>
  );
};

export default ChooseCtegory;
